import { League } from '../models';
import { LeagueRepository } from '../repositories';

export class GetUserLeaguesUseCase {
  constructor(private leagueRepository: LeagueRepository) {}

  async execute(userId: string): Promise<League[]> {
    return await this.leagueRepository.getUserLeagues(userId);
  }
}
